import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-320 pb-20" }

import CustomizerOverlay from '@/shared/product/customizer/ui/overlays/CustomizerOverlay.vue';
import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';
import { watch } from 'vue';
import SearchFacets from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacets.vue';
import SearchResult from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResult.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import useCustomizer from '@/shared/product/customizer/useCustomizer';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialAndColor',
  setup(__props) {

const { clearActiveCustomizerOverlay } = useCustomizer();
const { isActive, isClearedResult, setPending, search, clearSearch } = useMaterialAndColor();
const { variantId } = useProductDetailData();
const labels = useBlockLabels();

const init = async(active) => {
    if (active && isClearedResult.value) {
        setPending(true);
        await search();
        setPending(false);
    }
};

watch(isActive, init, { immediate: true });
watch(variantId, clearSearch);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomizerOverlay, {
    "is-open": _unref(isActive),
    title: _unref(labels).overlayChooseMaterialTitle,
    onClose: _unref(clearActiveCustomizerOverlay)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SearchFacets),
        _createVNode(SearchResult)
      ])
    ]),
    _: 1
  }, 8, ["is-open", "title", "onClose"]))
}
}

})